import i18n from '../../../../i18n';
import React, { useContext, useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';

import { ProtectedRouteContext } from '../../../Context';

import './LabelOnly.scss';

export default function LabelOnly(props) {
    const question = props.question;
    const { userSettings } = useContext(ProtectedRouteContext);
    const [lang, setLang] = useState(
        typeof userSettings?.LanguagePreference === 'string' ? userSettings.LanguagePreference : i18n.language
    );

    question.isValid = true;

    useEffect(() => {
        if (typeof userSettings?.LanguagePreference === 'string') {
            setLang(userSettings.LanguagePreference);
        }
    }, [userSettings.LanguagePreference]);

    return (
        <div className="question-wrapper label-only">
            <ReactMarkdown
                children={question.text[lang]}
                linkTarget="_blank"
            />
        </div>
    );
}
